// src/utils/imagePreflight.js
// Read image dims and validate against constraints.

export const readImageDims = (file) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
      URL.revokeObjectURL(url);
    };
    img.onerror = () => {
      reject(new Error('Could not read image dimensions.'));
      URL.revokeObjectURL(url);
    };
    img.src = url;
  });

export const preflightIcon = async (
  file,
  limits = { minW: 50, minH: 50, maxW: 250, maxH: 150 },
) => {
  const { width, height } = await readImageDims(file);
  const { minW, minH, maxW, maxH } = limits;

  if (width < minW || height < minH) {
    return {
      ok: false,
      message: `Icon too small (${width}×${height}). Min is ${minW}×${minH}px.`,
    };
  }
  if (width > maxW) {
    return {
      ok: false,
      message: `Icon too wide (${width}px). Max width is ${maxW}px.`,
    };
  }
  if (height > maxH) {
    return {
      ok: false,
      message: `Icon too tall (${height}px). Max height is ${maxH}px.`,
    };
  }
  return { ok: true, dims: { width, height } };
};
